export default __webpack_public_path__ + "static/media/SramanMukherjeee.326e2583.webp";